import PreviewFire from './PreviewFire';
export default PreviewFire;